module.exports = __webpack_public_path__ + "530c4de1ed1b3838c2350359161d181a.svg";